module.exports = __webpack_public_path__ + "4fd5bab784e3dc985f181fe1114688da.png";